export function createAsyncEntity() {
  return {
    initialized: false,
    pending: false,
    payload: null,
    error: null
  };
}